<template>
	<div class="payout-status-page">
		<ProfileMain
			v-if="isTablet"
			:phoneAuth="store.state.user.app_auth === 'phone'"
			:hasASP="store.state.user.user_state === 'current_with_ahs'"
			class="profile-main--margin-left"
			:fullName="fullName"
			:phone="store.state.user?.phone.number"
			:dataReady="dataReady"/>
		<PayoutStatus/>
	</div>
</template>

<script setup>

import ProfileMain from '@/entities/components/ProfileMain';
import { useStore } from 'vuex';
import { computed } from 'vue';
import PayoutStatus from '@/entities/components/PayoutStatus/PayoutStatus.vue';

const store = useStore();
const isTablet = computed(() => store.state.isTablet.isTablet);
const fullName = computed(() => `${store.state.user.first_name} ${store.state.user.last_name}`);
const dataReady = computed(() => {
	if (store.state.user.app_auth === 'phone') {
		return !!store.state.user?.phone.number;
	}

	return !!(store.state.user?.first_name && store.state.user?.last_name && store.state.user?.phone.number);
});
</script>

<style lang="scss" scoped>
@import "payout-status-page";
</style>
